import { Injectable } from '@angular/core';
import { NotifyService } from '@app/services';
import { CustomReportQuery } from '@app/models/reporting/custom-report-query.model';
import { CustomReportFilter } from '@app/models/reporting/custom-report-filter.model';

@Injectable()
export class CustomReportingService {
    constructor(private notify: NotifyService) {}

    async saveCustomReport(customReportQuery: CustomReportQuery): Promise<CustomReportQuery> {
        try {
            return await customReportQuery.save();
        } catch (err) {
            this.notify.error(err.message || 'Custom Report could not be saved');
        }
    }

    async saveCustomReportFilters(customReportId: number, customReportFilter: CustomReportFilter): Promise<any> {
        try {
            await customReportFilter.param('customReportId', customReportId).save();
        } catch (err) {
            this.notify.error(err.message || 'Custom Report Filters could not be saved');
        }
    }

    async deleteCustomReportFilter(customReportId: number, customReportFilter: CustomReportFilter): Promise<any> {
        try {
            await customReportFilter.param('customReportId', customReportId).delete();
        } catch (err) {
            this.notify.error(err.message || 'Custom Report Filters could not be saved');
        }
    }

    async deleteCustomReport(customReportQuery: CustomReportQuery): Promise<any> {
        try {
            await customReportQuery.delete();
        } catch (err) {
            this.notify.error(err.message || 'Custom Report could not be deleted.');
        }
    }
}
